// src/authConfig.js
import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: '829e941f-bd02-4bc8-ab8c-d2adffee4872',
    authority: 'https://login.microsoftonline.com/f01aeb10-788c-4137-b031-9eb6bcccd671',
    redirectUri: 'https://oil.spm-automation.com/redirect.html',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

// Scope for calling YOUR backend API (not Graph).
// This uses the app's own client ID as the audience.
export const apiTokenRequest = {
  scopes: [`api://${msalConfig.auth.clientId}/access_as_user`],
};
